import getBrowserHistory from 'yoda-core-components/lib/navigation/history/getBrowserHistory';

const queryToSearch = (query) => {
    return Object.keys(query)
        .map((key) => `${key}=${query[key]}`)
        .join('&');
};

/**
 * @param {Object} query
 */
export const addQueryReplaceUrl = (query) => {
    const location = { ...getBrowserHistory().location };
    location.search = queryToSearch(query);
    getBrowserHistory().replace(location);
};

/**
 * @param {Object} query
 */
export const addQueryNewUrl = (query) => {
    const location = { ...getBrowserHistory().location };
    location.search = queryToSearch(query);
    getBrowserHistory().push(location);
};

/**
 * @param String url
 * @param {Object} query
 */
export const doSoftNavigate = (url, query) => {
    // const location = Object.assign({}, getBrowserHistory().location);
    const newLocation = {
        pathname: url,
        query,
    };
    getBrowserHistory().push(newLocation);
};
